import { LuCheck } from "react-icons/lu";
import {
  Container,
  Description,
  GradientOverlay,
  Grid,
  IconWrapper,
  ImageContainer,
  ImageWrapper,
  List,
  ListItem,
  ListText,
  Section,
  StyledImage,
  Tag,
  TextContainer,
  Title
} from "./styles";

export default function Benefits() {
  const benefitsList = [
    "Redução de até 40% no tempo administrativo",
    "Diminuição de 30% nas faltas de pacientes",
    "Controle financeiro preciso e simplificado",
    "Tomada de decisão baseada em dados reais",
    "Atendimento mais personalizado e eficiente",
    "Comunicação aprimorada com os pacientes"
  ];

  return (
    <Section id="beneficios">
      <Container>
        <Grid>
          <div>
            <ImageWrapper>
              <GradientOverlay />
              <ImageContainer>
                <StyledImage
                  src="/images/dentist-benefits.png"
                  alt="Dentista usando o software em tablet"
                  loading="lazy"
                  width={600}
                  height={400}
                />
              </ImageContainer>
            </ImageWrapper>
          </div>

          <TextContainer>
            <Tag>Benefícios</Tag>
            <Title>Transforme sua clínica com tecnologia inteligente</Title>
            <Description>
              O DentalMap foi desenvolvido para potencializar a eficiência da
              sua clínica odontológica, reduzindo tarefas administrativas e
              melhorando a experiência dos pacientes.
            </Description>

            <List>
              {benefitsList.map((benefit, index) => (
                <ListItem key={index} $animationDelay={`${index * 100}ms`}>
                  <IconWrapper>
                    <LuCheck size={16} color="#0C6ACB" />
                  </IconWrapper>
                  <ListText>{benefit}</ListText>
                </ListItem>
              ))}
            </List>
          </TextContainer>
        </Grid>
      </Container>
    </Section>
  );
}
